import React, { useState, useEffect } from 'react';
import PhoneInput from '../widgets/phone';
import AddressFull from './Autocomplete/AddressFull';
import dictionarystreet from '../data/addresses.json';

import RadioWidgetPlain from './RadioWidget/radiowidget';

const Step2 = ({ formData, errors, onChange }) => {
  const [hasMunicipalCard, setHasMunicipalCard] = useState(null);
  const [showMunicipalCardInfo, setShowMunicipalCardInfo] = useState(false);

  // Ефект для перевірки наявності муніципальної картки (імітація)
  useEffect(() => {

    if (formData.applicant.hasRnokpp === 'no' && formData.applicant.documentDetails) {
      // Імітуємо перевірку за документом
      setTimeout(() => {
        //setHasMunicipalCard(Math.random() > 0.5); // Випадковий результат для демонстрації
        setShowMunicipalCardInfo(true);
      }, 1000);
    } else if (formData.applicant.rnokpp) {
      // Імітуємо перевірку за РНОКПП
      setTimeout(() => {
        //setHasMunicipalCard(Math.random() > 0.5); // Випадковий результат для демонстрації
        setShowMunicipalCardInfo(true);
      }, 1000);
    } else {
      setHasMunicipalCard(null);
      setShowMunicipalCardInfo(false);
    }
  }, [formData.applicant.rnokpp, formData.applicant.hasRnokpp, formData.applicant.documentDetails]);

  const handleHasRnokppChange = (value) => {
    onChange('applicant.hasRnokpp', value);
    // Скидаємо додаткові поля при зміні відповіді
    if (value === 'yes') {
      onChange('applicant.documentType', '');
      onChange('applicant.documentDetails', '');
    }
  };

  const handleDocumentTypeChange = (value) => {
    onChange('applicant.documentType', value);
    // Скидаємо реквізити при зміні типу документа
    onChange('applicant.documentDetails', '');
  };

  // Функція для форматування введення залежно від типу документа
  const formatDocumentDetails = (value, documentType) => {
    if (!value) return value;
    
    if (documentType === 'passport') {
      // Формат для паспорта: XXxxxxxx (2 літери + 6 цифр)
      let formattedValue = value.toUpperCase();
      
      // Розділяємо на літери та цифри
      const lettersPart = formattedValue.replace(/[^A-ZА-ЯІЇЄ]/g, '').slice(0, 2);
      const digitsPart = formattedValue.replace(/[^0-9]/g, '').slice(0, 6);
      
      // Складаємо відформатоване значення
      formattedValue = lettersPart;
      if (digitsPart.length > 0) {
        formattedValue += ' ' + digitsPart;
      }
      
      return formattedValue;
    } else if (documentType === 'idCard') {
      // Формат для ID картки: xxxxxxxxx (9 цифр)
      let formattedValue = value.replace(/[^0-9]/g, '');
      
      // Обмежуємо довжину до 9 цифр
      formattedValue = formattedValue.slice(0, 9);
      
      // Додаємо пробіли після кожних 3 цифр для кращої читабельності
      if (formattedValue.length > 6) {
        formattedValue = formattedValue.slice(0, 3) + ' ' + formattedValue.slice(3, 6) + ' ' + formattedValue.slice(6);
      } else if (formattedValue.length > 3) {
        formattedValue = formattedValue.slice(0, 3) + ' ' + formattedValue.slice(3);
      }
      
      return formattedValue;
    }

    const val_match = value.match(/[0-9]/g, '');

    return val_match && val_match.join("").slice(0,10) || ''; //RNOKPP formated
    
    return value;
  };

  const handleDocumentDetailsChange = (e) => {
    const rawValue = e.target.value;
    const formattedValue = formatDocumentDetails(rawValue, formData.applicant.documentType);
    onChange('applicant.documentDetails', formattedValue);
  };

  // Визначаємо, чи потрібно показувати текстове поле для адреси заявника
  const showTextAddress = formData.applicant.isAddressKyiv === "no" || 
                          (formData.applicant.isAddressKyiv === "yes" && formData.applicant.notFindKyivAddress === true);

  return (
    <div className="form-section">
      <h2 className="form-section-title">Дані про заявника</h2>
      
      <div className="form-row single">
        <div className="form-group">
          <label className="form-label">Прізвище</label>
          <input
            type="text"
            className={`form-control ${errors.applicantLastName ? 'is-invalid' : ''}`}
            placeholder=""
            value={formData.applicant.lastName}
            onChange={(e) => onChange('applicant.lastName', e.target.value)}
          />
          {errors.applicantLastName && <div className="invalid-feedback">{errors.applicantLastName}</div>}
        </div>
      </div>
      
      <div className="form-row two-cols">
        <div className="form-group">
          <label className="form-label">Імʼя</label>
          <input
            type="text"
            className={`form-control ${errors.applicantFirstName ? 'is-invalid' : ''}`}
            placeholder=""
            value={formData.applicant.firstName}
            onChange={(e) => onChange('applicant.firstName', e.target.value)}
          />
          {errors.applicantFirstName && <div className="invalid-feedback">{errors.applicantFirstName}</div>}
        </div>
        <div className="form-group">
          <label className="form-label">По батькові</label>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={formData.applicant.middleName}
            onChange={(e) => onChange('applicant.middleName', e.target.value)}
          />
          {errors.applicantMiddleName && <div className="invalid-feedback">{errors.applicantMiddleName}</div>}
        </div>
      </div>
      
      <div className="form-row single">
        <div className="form-group">
          <label className="form-label">Громадянство</label>
          <select
            className={`form-select ${errors.applicantCitizenship ? 'is-invalid' : ''}`}
            value={formData.applicant.citizenship}
            onChange={(e) => onChange('applicant.citizenship', e.target.value)}
          >
            <option>Україна</option>
            <option>Інше</option>
          </select>
          {errors.applicantCitizenship && <div className="invalid-feedback">{errors.applicantCitizenship}</div>}
        </div>
      </div>


    <RadioWidgetPlain id={'r-formData.applicant.hasRnokpp'} labels={["У мене є РНОКПП", "Відсутній"]} value={formData.applicant.hasRnokpp} title='Наявність РНОКПП' onChange={(b) => onChange('applicant.hasRnokpp', b)} />

            
      {/* Поле РНОКПП (показується тільки якщо є РНОКПП) */}
      {formData.applicant.hasRnokpp === 'yes' && (
        <div className="form-row single">
          <div className="form-group">
            <label className="form-label">РНОКПП</label>
            <input
              type="text"
              className={`form-control ${errors.applicantRnokpp ? 'is-invalid' : ''}`}
              placeholder=""
              value={formData.applicant.rnokpp}
              onChange={(e) => onChange('applicant.rnokpp', formatDocumentDetails(e.target.value, ""))}
            />
            {errors.applicantRnokpp && <div className="invalid-feedback">{errors.applicantRnokpp}</div>}
          </div>
        </div>
      )}
      
      {/* Додаткові поля для тих, хто не має РНОКПП */}
      {formData.applicant.hasRnokpp === 'no' && (
        <>
          <div className="form-row single">
            <div className="form-group">
              <label className="form-label">Вид документу, що посвідчує особу</label>
              <select
                className={`form-select ${errors.applicantDocumentType ? 'is-invalid' : ''}`}
                value={formData.applicant.documentType}
                onChange={(e) => handleDocumentTypeChange(e.target.value)}
              >
                <option value="">Оберіть тип документа</option>
                <option value="passport">паспорт</option>
                <option value="idCard">ID картка</option>
              </select>
              {errors.applicantDocumentType && <div className="invalid-feedback">{errors.applicantDocumentType}</div>}
            </div>
          </div>
          
          {formData.applicant.documentType && (
            <div className="form-row single">
              <div className="form-group">
                <label className="form-label">
                  {formData.applicant.documentType === 'passport' 
                    ? 'Серія та номер паспорта' 
                    : 'Номер ID картки'}
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.applicantDocumentDetails ? 'is-invalid' : ''}`}
                  placeholder={
                    formData.applicant.documentType === 'passport' 
                      ? 'СР 123456' 
                      : '123 456 789'
                  }
                  value={formData.applicant.documentDetails}
                  onChange={handleDocumentDetailsChange}
                  maxLength={formData.applicant.documentType === 'passport' ? 9 : 11} // 8 символів + пробіл
                />
                <small className="form-text text-muted">
                  {formData.applicant.documentType === 'passport' 
                    ? 'Формат: 2 літери + 6 цифр (наприклад: СР 123456)' 
                    : 'Формат: 9 цифр (наприклад: 123 456 789)'}
                </small>
                {errors.applicantDocumentDetails && <div className="invalid-feedback">{errors.applicantDocumentDetails}</div>}
              </div>
            </div>
          )}
        </>
      )}
      
      {/* Інформація про муніципальну картку */}
      {false && showMunicipalCardInfo && (
        <div className="form-row single">
          <div className="form-group">
            {hasMunicipalCard ? (
              <div className="alert alert-info">
                <strong>Підтверджено наявність муніципальної картки «Картка киянина»</strong>
              </div>
            ) : (
              <div className="alert alert-info">
                <strong>Відсутність муніципальної картки «Картка киянина»</strong>
                <p>
                  Відсутність муніципальної картки «Картка киянина» не впливає на позицію в електронній черзі 
                  на зарахування дитини в ЗДО, а лише на звільнення від сплати БФН, який за відсутності картки 
                  сплачується заявником або іншим законним представником дитини у розмірі, визначеним рішенням 
                  Київської міської ради на відповідний бюджетний рік.
                </p>
                <p>
                  <strong>Як отримати муніципальну картку «Картка киянина»:</strong><br />
                  Зверніться до найближчого Центру надання адміністративних послуг (ЦНАП) у місті Києві 
                  з документами, що посвідчують особу та підтверджують право на отримання картки.
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      
      <hr className="section-divider" />
      
      <h2 className="form-section-title">Контактні дані</h2>
      
      <div className="form-row single">
        <PhoneInput 
            label="Телефон" 
            value={formData.applicant.phone} 
            onChange={(e) => onChange('applicant.phone', e.target.value)} 
            error={errors.applicantPhone}/>
      </div>
      
      <div className="form-row single">
        <div className="form-group">
          <label className="form-label">Електронна пошта</label>
          <input
            type="email"
            className={`form-control ${errors.applicantEmail ? 'is-invalid' : ''}`}
            placeholder=""
            value={formData.applicant.email}
            onChange={(e) => onChange('applicant.email', e.target.value)}
          />
          {errors.applicantEmail && <div className="invalid-feedback">{errors.applicantEmail}</div>}
        </div>
      </div>

      <RadioWidgetPlain id={'r-formData.applicant.isAddressKyiv'} value={formData.applicant.isAddressKyiv}  title='Ви проживаєте в Києві?' onChange={(d)=>{
        onChange('applicant.isAddressKyiv', d);
        // Скидаємо позначку про відсутність адреси в довіднику при зміні відповіді
        if (d === "no") {
          onChange('applicant.notFindKyivAddress', false);
        }
      }} />

      {/* Чекбокс для адреси не знайденої в довіднику (тільки для Києва) */}
      {formData.applicant.isAddressKyiv === "yes" && (
        <div className="form-group">
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="applicant-not-find-kyiv-address"
              checked={formData.applicant.notFindKyivAddress === true}
              onChange={(e) => {
                onChange('applicant.notFindKyivAddress', e.target.checked);
                // Якщо чекбокс активований, очищаємо об'єкт адреси
                if (e.target.checked) {
                  onChange('applicant.address', { district: '', street: '', building: '', corpus: '' });
                }
              }}
            />
            <label className="form-check-label" htmlFor="applicant-not-find-kyiv-address">
              Адреса в Києві, але відсутня в довіднику
            </label>
          </div>
        </div>
      )}

      {/* Вибір адреси з довідника (для Києва, адреса є в довіднику) */}
      {formData.applicant.isAddressKyiv === "yes" && formData.applicant.notFindKyivAddress !== true && (
        <AddressFull 
          dictionary={formData.dictionary}  
          title='Адреса проживання' 
          value={formData.applicant.address} 
          fieldsPath='applicant.address' 
          onChange={onChange} 
          error={errors.applicantAddress} 
        />
      )}

      {/* Текстове поле для адреси (для іногородніх або адрес не знайдених в довіднику) */}
      {showTextAddress && (
        <div className="form-group">
          <label className="form-label">
            {formData.applicant.isAddressKyiv === "yes" 
              ? "Адреса проживання в Києві (відсутня в довіднику)" 
              : "Адреса проживання"}
          </label>
          <input
            type="text"
            className={`form-control ${errors.applicantAddress ? 'is-invalid' : ''}`}
            placeholder=""
            value={formData.applicant.addressStr}
            onChange={(e) => onChange('applicant.addressStr', e.target.value)}
          />
          {errors.applicantAddress && <div className="invalid-feedback">{errors.applicantAddress}</div>}
        </div>
      )}

    </div>
  );
};

export default Step2;